import { HTMLAttributes } from 'react';

/**
 * Spinner — loading indicator. CSS-only (no JS animation).
 * The keyframes definition lives in global.css to keep the atom export
 * a single React component.
 *
 * Phase 11 Block 6 PR 2.
 */

export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface SpinnerProps extends HTMLAttributes<HTMLSpanElement> {
  size?: SpinnerSize;
  label?: string;
}

const sizeMap: Record<SpinnerSize, number> = { sm: 12, md: 16, lg: 24 };

export function Spinner({ size = 'md', label = 'Loading', style, ...rest }: SpinnerProps) {
  const px = sizeMap[size];
  return (
    <span
      role="status"
      aria-label={label}
      style={{
        display: 'inline-block',
        width: px,
        height: px,
        border: '2px solid currentColor',
        borderTopColor: 'transparent',
        borderRadius: '50%',
        animation: 'spin 0.7s linear infinite',
        verticalAlign: 'middle',
        ...style,
      }}
      {...rest}
    />
  );
}
